// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1aruc","inner":"Form_inner__1isA4","range":"Form_range__2l0-r","name":"Form_name__3WQnU","actions":"Form_actions__3XPmr"};